import { CAMPAIGN_INFO_TEMPLATE, TEAM_TEMPLATE } from './editorOptions'

export const getRegisterLabelOptions = (isUpdate?: boolean) => ({
  name: { required: 'Name is required.' },
  alias: { required: 'Alias is required. ' },
  country_codes: { required: 'Country Code is required. ' },
  max_radio_stations: {
    max: {
      value: 50,
      message: 'Maximum number of radio stations should be less then 50.'
    },
    min: {
      value: 0,
      message: 'Maximum number of radio stations should be more then 0.'
    },
    pattern: {
      value: /^[0-9]+$/,
      message: 'Maximum number of radio stations should be a number.'
    },
    ...(isUpdate && {
      required: 'Maximum number of radio stations should be a number.'
    })
  }
})

export const defaultValues = {
  name: '',
  alias: '',
  country_codes: []
}

export const defaultTemplate = {
  campaign_info: {
    template_type: 'campaign_info',
    template: CAMPAIGN_INFO_TEMPLATE
  },
  team_info: {
    template_type: 'team_info',
    template: TEAM_TEMPLATE
  },
  story_guide: {
    template_type: 'story_guide',
    template: '<p>Set up story guide</p>'
  }
}
